var map = {
	"./admin/reducer.js": 384,
	"./album/reducer.js": 664,
	"./announcement/reducer.js": 658,
	"./class/reducer.js": 397,
	"./customer/reducer.js": 398,
	"./homework/reducer.js": 659,
	"./organization/reducer.js": 399,
	"./posts/reducer.js": 400,
	"./resource/reducer.js": 401,
	"./school/reducer.js": 660,
	"./sessions/reducer.js": 402,
	"./teacher/reducer.js": 403,
	"./user/reducer.js": 404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 383;